import DNACanvas from './DNACanvas';

export default DNACanvas;
